import { Controller } from 'stimulus';

import { searchService } from '../libs/search_service';
import { uiService } from '../libs/ui_service';

export default class extends Controller {
  initialize() {
    this.element.addEventListener('input', (event) => {
      searchService.searchTerm = event.target.value;
      uiService.updateTable();
    });
  }
}
